import React from "react";

import BaseErrorPage from "./base-error-page";

interface MaintenanceScreenProps {
  title?: string;
  description?: string;
}

export default function MaintenanceScreen({
  title,
  description,
}: MaintenanceScreenProps) {
  return (
    <BaseErrorPage
      pageName="MaintenanceScreen"
      pageBody={
        <h4 className="mt-4 text-center">
          <b>{title || "Northbeam is undergoing scheduled maintenance."}</b>{" "}
          <div className="mt-3">
            {description ||
              "We'll be back online shortly. " +
                "For urgent requests, please contact us using the button below."}
          </div>
        </h4>
      }
    />
  );
}
